import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../components/registration/signin/loginSlice";
import updatePasswordReducers from "../components/registration/credentialupdate/updatePasswordSlice";
import customerReducers from "../components/masters/customer/customerSlice";
import genderReducer from "../components/masters/gender/genderSlice";
import itemReducers from "../components/masters/item/itemSlice";
import uomReducer from "../components/masters/uom/uomSlice";
import salesReducers from "../components/transactions/sales/salesSlice";
import collectionReducer from "../components/transactions/collection/collectionSlice";
import collectionReportReducer from "../components/report/collection/collectionReportSlice";




// import signUpReducer from "../Components/registration/signupSlice";
// import signInReducer from "../Components/login/signInSlice";
// import genderReducer from "../Components/masters/Gender/genderSlice";
// import uomReducers from "../Components/masters/uom/uomSlice";
// import categoryReducers from "../Components/masters/category/categorySlice";
// import itemReducers from "../Components/masters/item/itemSlice";
// import customerTypeReducers from "../Components/masters/customertype/customerTypeSlice";

// import salesReducers from "../Components/transactions/sales/salesSlice";
// import salesReportReducers from "../Components/reports/sales/salesReportSlice";

export const store = configureStore({
  // Reducer will comes inside the Store.
  reducer: {
    login: loginReducer,
    resetpassword: updatePasswordReducers,
    customers: customerReducers, // customers is the name of customerReducers(this is exporting from customerSlice.js)
    genders: genderReducer, // genders is the name of genderReducer(this is exporting from genderSlice.js)
    items: itemReducers, // items is the name of itemReducers(this is exporting from itemSlice.js)
    uoms: uomReducer, //uoms is the name of uomReducer(this is exporting from uomSlice.js)
    sales: salesReducers, //sales is the name of salesReducers(this is exporting from salesSlice.js)
    collections: collectionReducer, //collections is the name of salesReducers(this is exporting from collectionSlice.js)
    collectionsreport: collectionReportReducer //collectionsreport is the name of collectionReportReducers(this is exporting from collectionReportSlice.js)
    
    // signUps: signUpReducer,  signUps is the name of signUpReducer(this is exporting from signupSlice.js)
    // signIns: signInReducer,  signIns is the name of signInReducer(this is exporting from signInSlice.js)
    // genders: genderReducer,  genders is the name of genderReducer(this is exporting from genderSlice.js)

    // categories: categoryReducers,  categories is the name of categoryReducers(this is exporting from categorySlice.js)

    // customertypes: customerTypeReducers,  customertypes is the name of customerTypeReducers(this is exporting from customerTypeSlice.js)

    // sales: salesReducers,  sales is the name of salesReducers(this is exporting from salesSlice.js)
    // salesreport: salesReportReducers,  salesreport is the name of salesReportReducers(this is exporting from salesReportSlice.js)
  },
});
